import { Box, Button, Card, Chip, Grid, IconButton, Modal, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { formatDateTime } from '../../../../utils/dateUtils';
import Loading from '../../../../components/Loader/Loading';
import { ProviderServices } from '../../CrudServices';
import { AddToPhotos, Close, FitScreen, ZoomIn, ZoomOut } from '@mui/icons-material';
import noImage from '../../../../assets/images/no_image_available.png'
import { Helpers } from '../../../../services/Helpers';
import NoRowsLayout from '../../../../components/Layout/NoRowsLayout';

const WalletTransactions = ({refreshTransactionList,setRefreshTransactionList}) => {
    const {id} = useParams();
    const columns = [
        // { field: 'id', headerName: 'ID', width: 100 },
        // { field: 'transactionNo', headerName: 'Transaction No.',flex: 1.75, headerAlign: 'center', sortable:false,
        //     renderCell: (params) => (
        //         <Box sx={{p: 1,width:'100%'}}>
        //             <Typography sx={{fontSize:'0.65rem',color:'#1976d2'}}>{params.row.transactionNo}</Typography>
        //         </Box>
        //     )
        // },
        
        { field: 'createdAt', headerName: 'Transaction Date', flex: 1.5, headerAlign: 'center', sortable:false,
            renderCell: (params) => (
                <Box sx={{p: 1,width:'100%',textAlign:'center'}}>
                    <Typography sx={{fontSize:'0.65rem',color:'#3e3e3e'}}>{params.row.createdAt ? formatDateTime(params.row.createdAt):''}</Typography>
                </Box>
            )
        },
        // { field: 'expiresOn', headerName: 'Expire On', flex: 1, headerAlign: 'center', sortable:false,
        //     renderCell: (params) => (
        //         <Box sx={{p: 1,width:'100%'}}>
        //             <Typography sx={{fontSize:'0.65rem',color:'#3e3e3e'}}>{params.row.wallet?.expireDate ? formatDateTime(params.row.wallet?.expireDate,'date'):''}</Typography>
        //         </Box>
        //     )
        // },
        { field: 'transactionType', headerName: 'Type', flex: 1, headerAlign: 'center', sortable:false,
            renderCell: (params) => (
                <Box sx={{p: 1,width:'100%',textAlign:'center'}}>
                    {params.row.creditAmount > 0 && 
                      <Chip label="Credit" sx={{fontSize:'0.65rem'}} color='success' size='small'/>
                    // <Typography sx={{fontSize:'0.65rem',color:'#ffff',bgcolor:'green',borderRadius:'4rem',p:.5,width:'fit-content'}}>Credit</Typography>
                    }
                    {params.row.debitAmount > 0 && 
                      <Chip label="Debit" sx={{fontSize:'0.65rem'}} color='error' size='small'/>
                    // <Typography sx={{fontSize:'0.65rem',color:'#3e3e3e',bgcolor:'red',borderRadius:'5px',p:1}}>Debit</Typography>
                    }
                </Box>
            )
        },
        { field: 'previousBalance', headerName: 'Prev. Balance', flex: 1.75, headerAlign: 'center', sortable:false,
            renderCell: (params) => (
                <Box sx={{p: 1,width:'100%',textAlign:'center'}}>
                    <Typography sx={{fontSize:'0.65rem',color:'#3e3e3e'}}>₹ {params.row.previousBalance}</Typography>
                </Box>
            )
        },
        { field: 'amount', headerName: 'Credit/Debit Amount', flex: 1.75, headerAlign: 'center', sortable:false,
            renderCell: (params) => (
                <Box sx={{p: 1,width:'100%',textAlign:'center'}}>
                  <Chip label={params.row.creditAmount > 0 ? `+ ₹ ${params.row.creditAmount}` : `- ₹ ${params.row.debitAmount}`} 
                    sx={{fontSize:'0.65rem'}} 
                    color={params.row.creditAmount > 0 ? 'success' : 'error'} 
                    size='small'/>
                  {/* {params.row.creditAmount > 0 ?
                    <Typography sx={{fontSize:'0.65rem',color:'green'}}>₹ {params.row.creditAmount}</Typography>
                    :
                    <Typography sx={{fontSize:'0.65rem',color:'red'}}>₹ {params.row.debitAmount}</Typography>
                  } */}
                </Box>
                // <Box sx={{p: 1,width:'100%'}}>
                //     <Typography sx={{fontSize:'0.65rem',color:'#3e3e3e'}}>₹ {params.row.creditAmount>0 ? params.row.creditAmount : params.row.debitAmount}</Typography>
                  // <Typography sx={{fontSize:'0.65rem',color:'#3e3e3e'}}>₹ {params.row.creditAmount>0 ? params.row.creditAmount : params.row.debitAmount}</Typography>
                // </Box>
            )
        },
        { field: 'currentBalance', headerName: 'Net Balance', flex: 1.75, headerAlign: 'center', sortable:false,
            renderCell: (params) => (
                <Box sx={{p: 1,width:'100%',textAlign:'center'}}>
                  <Chip label={`₹ ${params.row.currentBalance}`} sx={{fontSize:'0.65rem'}} color={params.row.currentBalance > 0 ? 'success' : 'error'} size='small'/>
                  {/* <Typography sx={{fontSize:'0.65rem',color:'#3e3e3e'}}>₹ {params.row.currentBalance}</Typography> */}
                </Box>
            )
        },
        {
          field: 'image',
          headerName: 'Image',
          headerAlign: 'center',
          flex: .5,
          renderCell: (params) => (
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%',justifyContent:'center' }}>
              <Box>
                {params.row.image ? (
                  // <img
                  //   //   src={params.row.images} 
                  //   src={`${Helpers.ImagePathUrl()}/booking-payment/sm/${params.row.image}`}
                  //   alt={params.row.title}
                  //   style={{ width: '2rem', height: '2rem', objectFit: 'cover' }}
                  // />
                  <Button size='small' variant="contained" color="primary" sx={{ fontSize: '0.6rem' }} onClick={() => window.open(`${Helpers.ImagePathUrl()}/expert-wallet/${params.row.image}`,'_blank')}>View </Button>
                ) : (
                  // <Skeleton variant="rectangular" width={35} height={35} animation={false} />
                  <img
                    //   src={params.row.images} 
                    src={noImage}
                    alt={params.row.title+'image_not_available'}
                    style={{ width: '2rem', height: '2rem', objectFit: 'cover' }}
                  />
                )}
              </Box>
            </Box>
          ),
        },
    ];
    const [rowdata, setRowData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [allRowCount, setAllRowCount] = useState(0);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 5,
        filters: {
            // searchKey: '',
            sortKey: '',
            sortDirection: 'desc',
            // filterOptions: [],
        },
    });
    const handlePaginationChange = (newPagination) => {
        setPaginationModel({
          ...paginationModel,
          page: newPagination.page,
          pageSize: newPagination.pageSize
        });
    };
    // const NoRowsLayout = () => {
    //     return (
    //         <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>
    //             <Typography variant="h6" color="textSecondary">No records found</Typography>
    //         </Grid>
    //     );
    // }
    // const Loading = () => {
    //     return (
    //         <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>
    //             <Typography variant="h6" color="textSecondary">Loading...</Typography>
    //         </Grid>
    //     );
    // }
    const fetchWalletTransactions = async () => {
        setLoading(true);
        const response = await ProviderServices.getWalletTransactions(paginationModel,id);
        // const response = await ProviderServices.getWalletTransactions(id);

        console.log("response",response);
        if (response && response.success=='1') {
            if (response.data && response.data?.length > 0) {
                setRowData(response.data);
                setAllRowCount(response.totalItems);      
            } else {
                setRowData([]);
                setAllRowCount(0);
            }
        }
        setLoading(false);
    }
    useEffect(() => {
        fetchWalletTransactions();
    }, [paginationModel]);
    useEffect(() => {
        if(refreshTransactionList){
            fetchWalletTransactions();
            setRefreshTransactionList(false);
        }
    }, [refreshTransactionList]);
  return (
    <Card>
        <Box sx={{p:'.5% 1%',border:'2px solid lightGray',bgcolor:'lightGray'}}>
            <Typography sx={{fontWeight:'600',fontSize:'0.85rem'}}>Wallet Transaction History</Typography>
        </Box> 
        <Box sx={{ overflow: "auto" }}>
          <Box 
            sx={{ 
              width: "100%", display: "table",  tableLayout: "fixed", 
              backgroundColor: "#fff", borderRadius: '.5rem',
              '& .odd': {
                bgcolor: 'white',
              },
              '& .even': {
                bgcolor: '#ECECEC',
              },
            }}>
      
            {/* {loading && <Loading/>} */}
            {/* custom toolbar */}
            {/* <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between',alignItems:'center',px:'1%' }}>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <MultiColumnFilter
                  filterableColumns={filterableColumns}
                  onApplyFilter={handleApplyFilter}
                  externalClear={clearMultiFilter}
                  defaultFilterOptions={paginationModel.filters.filterOptions}
                />
                <ExportAll 
                  paginationModel={paginationModel} 
                  columns={columns} 
                  // statusOptions={statusOptions} 
                />
              </Box>
              <Box>
                <TextField
                  value={quickFilterText}
                  onChange={(event) => setQuickFilterText(event.target.value)}
                  placeholder="Quick Search ..."
                  size="small"
                  fullWidth
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      paddingLeft: '0px',
                    }
                  }}
                  InputProps={{
                    inputProps: {
                      style: {
                        height: '0.6rem',
                        // textTransform: 'uppercase',
                        fontSize: 'x-small'
                      },
                    },
                    startAdornment: (
                      <InputAdornment position="start">
                        <IconButton>
                          <Search sx={{fontSize:'x-small'}}/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Box> */}
            <DataGrid
              rows={rowdata}
              columns={columns.map((col) => ({
                ...col,
                flex: col.flex || 1, // Ensure columns resize dynamically
                minWidth: col.minWidth || 180, // Set a minimum width to avoid overlap
              }))}
              // getRowId={(row) => row.id}
              //checkboxSelection={true}
              rowCount={allRowCount}  // Use the length of the filtered list
              pageSizeOptions={[5, 10, 20, 50, 100]}
              paginationModel={paginationModel}
              paginationMode="server"
              onPaginationModelChange={handlePaginationChange}
            //   filterModel={filterModel}
              loading={loading}

              disableColumnMenu
              disableRowSelectionOnClick
              // disableColumnFilter
              // disableColumnSelector
              disableDensitySelector
              slots={{
                // toolbar: GridToolbar,
                noRowsOverlay: ()=>(<NoRowsLayout message={"No Transactions Found"}/>),
                loadingOverlay: Loading,
              }}
              // slotProps={{
              //   toolbar: {
              //     showQuickFilter: true,  
              //   },
              // }}
              // rowHeight={50}
              autoHeight
              getRowHeight={() => 'auto'}
              sx={{
                  '& .MuiDataGrid-cell': {
                  border: 1,
                  borderRight: 0,
                  borderTop: 0,
                  borderColor: 'lightgrey',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  },
                  '& .MuiDataGrid-columnHeaders': {
                  borderBottom: '2px solid rgba(224, 224, 224, 1)',
                  borderTop: '2px solid rgba(224, 224, 224, 1)',
                  fontWeight: 600,
                  fontSize: '0.75rem',
                  p:0,
                  height: 'fit-content',
                  minHeight:'0 !important',
                  height:'2rem'
                  },
                  '& .MuiDataGrid-columnHeader': {
                  borderLeft: '1px solid rgba(224, 224, 224, 1)',
                  '&:last-child': {
                      borderRight: 'none',
                  },
                  },
                  '& .MuiDataGrid-columnHeaderTitle': {
                  fontWeight: 600,
                  color: '#3e3e3e'
                  },
                  '& .MuiDataGrid-row': {
                  '&:last-child .MuiDataGrid-cell': {
                      borderBottom: '1px solid rgba(224, 224, 224, 1)',
                  },
                  '& .MuiDataGrid-cell:last-child': {
                      borderRight: 'none',
                  },
                  },
                  '& .MuiDataGrid-columnSeparator': {
                  display: 'none',
                  },
              }}
            />
          </Box>
        </Box>
    </Card>
  );
}

export default WalletTransactions;
